import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import { ApproveRefundRequest } from "../../../Redux/Action/MasterAdminAction";
import { useState } from "react";

export const RejectReasonModel = ({ setRejectReasonModel , userDetail,setRefundModal,rejectReasonModel}) => {
  
  const dispatch = useDispatch();
  
  const [rejectReason, setRejectReason] = useState("");

  
  const handleRefundRequest = async (e) => {
    e.preventDefault();
    try {
      const data={
        req_id:userDetail?.req_id,
        request_status:false,
        note :rejectReason
      }
      setRefundModal(false);
      dispatch(ApproveRefundRequest(data, setRejectReasonModel));
    } catch (error) {
    }
  };


  return (
    <>
    {rejectReasonModel && (
          <div
            className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
            onClick={() => setRejectReasonModel(false)}
          />
        )}
       <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          rejectReasonModel ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
      <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center">
            <div className="my-[7px] text-xl font-semibold text-gray-900">Reject Reason</div>
           </div>
            <button
              onClick={() => {
                setRejectReasonModel(false);
              }}
            >
              <MdClose className="text-2xl text-gray-500 hover:text-black" />
            </button>
          </div>
        <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          <form onSubmit={handleRefundRequest} id="formId">
                  <textarea
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm  outline-[#FCDD00] input w-full"
                    value={rejectReason}
                    placeholder="Enter Reject Reason"
                    onChange={(e) => setRejectReason(e.target.value)}
                    rows="10"
                    required
                  />
          </form>
      </div>
      <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <button
            type="submit"
            form="formId"
            className="w-full px-4 py-3 font-medium text-white transition-colors bg-red-600 rounded-lg d-red-700ration-200 hover:bg-v focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Reject
          </button>
          <button
            onClick={() => setRejectReasonModel(false)}
            className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};
